export enum InvoiceTypeEnum {
  INITIAL = 'Initial',
  REGULAR = 'Regular',
  ADDITIONAL = 'Additional'
}
